import * as THREE from "three";
import { memoize, onCleanup } from "@apendua/signal";

/**
 * The polytope itself. Colour comes entirely from the vertex attribute the
 * geometry carries — the palette for the shell's own faces, a dark neutral for
 * anything exposed by a cut — so one material serves every piece.
 *
 * `emissive` is the highlight channel: at zero the material is lit normally,
 * and lifting it washes a cool light over whichever cluster the ray is
 * currently on. Two sides, because a piece being dragged is routinely seen
 * from inside the shell it came out of.
 */
export const pieceMaterial = memoize((emissiveIntensity: number) => {
  const material = new THREE.MeshStandardMaterial({
    side: THREE.DoubleSide,
    vertexColors: true,
    metalness: 0.12,
    roughness: 0.42,
    emissive: new THREE.Color("#7aa7ff"),
    emissiveIntensity,
    envMapIntensity: 0.8,
  });
  onCleanup(() => {
    material.dispose();
  });
  return material;
});

/** The dot drawn wherever a controller ray lands. */
export const cursorMaterial = memoize((color: string) => {
  const material = new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity: 0.85,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
  });
  onCleanup(() => {
    material.dispose();
  });
  return material;
});

export const sphereGeometry = memoize((radius: number) => {
  const geometry = new THREE.SphereGeometry(radius, 16, 12);
  onCleanup(() => {
    geometry.dispose();
  });
  return geometry;
});
